module.exports = __webpack_public_path__ + "static/media/zone1-slab.8d0d5531.png";